import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { LEGAL, PRE_LAWYER_BANNER } from "../lib/legal";

export function LegalLayout({ title, lastUpdated, children, testid }) {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid={testid}>
      <header className="border-b border-border px-6 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-7 h-7 bg-[#007AFF] flex items-center justify-center">
            <span className="text-white font-[Chivo] text-xs">⚡</span>
          </div>
          <span className="font-[Chivo] tracking-tight">MICRO/TRADE</span>
        </Link>
        <Link to="/login" className="text-sm text-neutral-400 hover:text-white">Back to App</Link>
      </header>

      <article className="max-w-3xl mx-auto px-6 py-12">
        <div className="mb-8 border border-[#FFB300]/30 bg-[#FFB300]/5 p-4 flex gap-3" data-testid="lawyer-review-banner">
          <AlertTriangle size={18} className="text-[#FFB300] shrink-0 mt-0.5" />
          <p className="text-xs text-neutral-300 leading-relaxed">
            <span className="font-[Chivo] text-[#FFB300]">⚠ Pre-lawyer template:</span> {PRE_LAWYER_BANNER}
          </p>
        </div>

        <div className="label-xs">{lastUpdated || `Effective ${LEGAL.effectiveDate}`}</div>
        <h1 className="text-4xl font-[Chivo] tracking-tight mt-2 mb-8">{title}</h1>

        <div className="prose prose-invert prose-neutral max-w-none prose-headings:font-[Chivo] prose-headings:tracking-tight prose-h2:text-2xl prose-h2:mt-12 prose-h2:mb-4 prose-h3:text-lg prose-h3:mt-8 prose-h3:mb-3 prose-p:leading-relaxed prose-p:text-neutral-300 prose-strong:text-white prose-a:text-[#007AFF] prose-li:text-neutral-300">
          {children}
        </div>

        <footer className="mt-16 pt-6 border-t border-border text-xs text-neutral-500 space-y-1">
          <div>{LEGAL.companyName} · {LEGAL.jurisdiction}</div>
          <div>Contact: <a href={`mailto:${LEGAL.legalEmail}`} className="text-[#007AFF]">{LEGAL.legalEmail}</a></div>
          <nav className="flex gap-3 mt-2">
            <Link to="/legal/terms" className="hover:text-white">Terms</Link>
            <Link to="/legal/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/legal/risk" className="hover:text-white">Risk Disclosure</Link>
            <Link to="/legal/disclaimer" className="hover:text-white">Disclaimer</Link>
            <Link to="/legal/cookies" className="hover:text-white">Cookies</Link>
          </nav>
        </footer>
      </article>
    </div>
  );
}
